export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYAQAAAADIDABVAAAAAnRSTlMAAHaTzTgAAAARSURBVHgBY8AFmP8fIAnjAADsMRUZMrvt6QAAAABJRU5ErkJggg=="